import { ParcellaGiudiziale } from '../parcella-giudiziale';
import { FaseFascicolo } from './fase-fascicolo';

export class FaseCompensoParcella {
  id: string;
  fase: FaseFascicolo;
  parcella: ParcellaGiudiziale;
  compenso: any;
}
